import React, { memo } from "react"
import { formatTimeStr } from "utils/dates"
import { Button } from "antd"

const _TranscriptionLine = ({ endTime, text, onClick }) => {
  return (
    <span className="transcription-text-container">
      <Button className="transcription-time-button" onClick={onClick}>
        <p className="transcription-time-text">{formatTimeStr(endTime)}</p>
      </Button>
      <p className="transcription-text">{text}</p>
    </span>
  )
}

export const TranscriptionLine = memo(_TranscriptionLine)